export function formatAddressLabel(a) {
	return !_.isObject(a) ? '' : _.toString(a.label ? a.label : a.name);
}

export function formatAddress(a, EOL = ' ', include_name = true) {
	if (!_.isObject(a)) {
		return '';
	}

	const lines = [];
	if (a.name && include_name) {
		if (include_name !== 'distinct' || !_.includes(formatAddressLabel(a), a.name)) {
			lines.push(a.name);
		}
	}
	if (a.line1) {
		lines.push(a.line1);
	}
	if (a.line2) {
		lines.push(a.line2);
	}
	if (_.compact([a.city, a.state, a.postal_code])) {
		lines.push(_.compact([a.city, a.state]).join(', ') + (a.postal_code ? ' ' + a.postal_code : ''));
	}
	if (a.country && !isUSA(a.country)) {
		lines.push(a.country);
	}

	return _.compact(_.map(lines, _.trim)).join(EOL);
}

export function parseErrorResponse(error) {
	const response = error['data'];

	if (response && response['error']) {
		return response['error']['data'] && response['error']['data']['message']
			? response['error']['data']['message']
			: (response['error']['message']
				? response['error']['message']
				: 'Unknown Error. Please, try again');
	}

	return 'Unknown Error. Please, try again';
}

export function formatPrice(amount) {
	amount = parseFloat(amount);
	return !_.isNaN(amount) ? _.round(amount, 2).toFixed(2) : '';
}

export function isUSA(country) {
	return country && (typeof country === 'string') && (country.toLowerCase() === 'us' || country.toLowerCase() === 'united states');
}

export function formatDate(date) {
	if (!date) return null;

	const [year, month, day] = date.split('-');
	return `${month}/${day}/${year}`;
}

export function formatBraintreeFieldName(names, separator = ', ') {
	const result = [];

	for (let name of names) {
		switch (name) {
			case 'number':
				result.push('Credit Card Number');
				break;
			case 'expirationDate':
				result.push('Expiration Date');
				break;
			case 'cvv':
				result.push('CVV');
				break;
			default:
				result.push(name);
				break;
		}
	}

	return result.join(separator);
}
